import { render } from "./PH.vue?vue&type=template&id=2d236f7b"
import script from "./PH.vue?vue&type=script&lang=js"
export * from "./PH.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__